import { render, staticRenderFns } from "./CompanyFormDialog.vue?vue&type=template&id=8bc9825a"
import script from "./CompanyFormDialog.vue?vue&type=script&lang=js"
export * from "./CompanyFormDialog.vue?vue&type=script&lang=js"
import style0 from "./CompanyFormDialog.vue?vue&type=style&index=0&id=8bc9825a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports